<template>
  <define-radio-yes>
    <pf-radio
      :label="labelYes"
      :name="name"
      :value="true"
      :checked="modelValue === true"
      @change="emit('update:modelValue', true)"
      :required="required"
      :ouia-id="`wizard-${name}-true`"
    >
      <template v-if="$slots['label-yes']" #label>
        <slot name="label-yes" />
      </template>
      <template v-if="$slots['description-yes']" #description>
        <slot name="description-yes" />
      </template>
    </pf-radio>
  </define-radio-yes>

  <wizard-question v-bind="$attrs">
    <template v-if="$slots.default" #description>
      <slot />
    </template>

    <radio-yes v-if="!firstNo" />

    <pf-radio
      :label="labelNo"
      :name="name"
      :value="false"
      :checked="modelValue === false"
      @change="emit('update:modelValue', false)"
      :required="required"
      :ouia-id="`wizard-${name}-false`"
    >
      <template v-if="$slots['label-no']" #label>
        <slot name="label-no" />
      </template>
      <template v-if="$slots['description-no']" #description>
        <slot name="description-no" />
      </template>
    </pf-radio>

    <radio-yes v-if="firstNo" />
  </wizard-question>
</template>

<script setup lang="ts">
import { createReusableTemplate } from '@vueuse/core';
import type { ComponentProps } from 'vue-component-type-helpers';
import { $t as _t } from '@/i18n';
import { useWizardQuestion } from '@/wizard';
import WizardQuestion from '../questions/wizard-question.vue';

type WizardQuestionProps = ComponentProps<typeof WizardQuestion>;

interface Props extends /* @vue-ignore */ WizardQuestionProps {
  modelValue: boolean | undefined | null;
  name: string;
  required?: boolean;
  labelYes?: string;
  labelNo?: string;
  firstNo?: boolean;
}

defineOptions({
  inheritAttrs: false,
});

withDefaults(defineProps<Props>(), {
  labelYes: _t('Sì'),
  labelNo: _t('No'),
});

const emit = defineEmits<{
  (name: 'update:modelValue', v: boolean): void;
}>();

defineSlots<{
  default?: (props?: Record<never, never>) => any;
  'description-yes'?: (props?: Record<never, never>) => any;
  'description-no'?: (props?: Record<never, never>) => any;
  'label-yes'?: (props?: Record<never, never>) => any;
  'label-no'?: (props?: Record<never, never>) => any;
}>();

useWizardQuestion();

const { define: DefineRadioYes, reuse: RadioYes } = createReusableTemplate();
</script>
